import { render, staticRenderFns } from "./ChallengeList.vue?vue&type=template&id=046fb836&scoped=true"
import script from "./ChallengeList.vue?vue&type=script&lang=js"
export * from "./ChallengeList.vue?vue&type=script&lang=js"
import style0 from "./ChallengeList.vue?vue&type=style&index=0&id=046fb836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046fb836",
  null
  
)

export default component.exports